import React from 'react';
import { LiaTimesSolid } from 'react-icons/lia';
import { withTheme } from '../ThemeProvider';
import { Header } from './Header';
import { StyledDrawer } from './styles';
import { DrawerProps } from './types';

const DrawerComponent: React.FC<DrawerProps> = ({
  Header: CustomHeader,
  Footer: CustomFooter,
  title,
  icon,
  footerContent,
  classes,
  styles,
  onClose,
  loading = false,
  showFooter = true,
  closeIcon = <LiaTimesSolid size={24} className="text-primary cursor-pointer hover:opacity-70" />,
  children,
  ...rest
}: DrawerProps) => {
  const headerContent = CustomHeader ?? <Header title={title} icon={icon} />;

  const renderFooter = () => {
    if (CustomFooter) return CustomFooter;
    if (footerContent && showFooter) return footerContent;
    return null;
  };

  const handleClose = (e: React.MouseEvent | React.KeyboardEvent) => {
    if (onClose) {
      onClose(e);
    }
  };

  return (
    <StyledDrawer
      title={headerContent}
      footer={renderFooter()}
      onClose={handleClose}
      closeIcon={closeIcon}
      className={classes?.wrapper}
      styles={{
        wrapper: { ...(styles?.wrapper || {}) },
        content: { ...(styles?.content || {}) },
        mask: { ...(styles?.mask || {}) },
        body: { ...(styles?.body || {}) },
        header: { ...(styles?.header || {}) },
        footer: { ...(styles?.footer || {}) },
      }}
      rootClassName={classes?.mask}
      loading={loading}
      {...rest}
    >
      {children}
    </StyledDrawer>
  );
};

export const Drawer = withTheme(DrawerComponent);
